import { useTranslation } from 'react-i18next'
import { useEffect, useState } from 'react'

import { primaryButtonStyle } from '../styles/buttonStyles'
import {
  footerModalActionsStyle,
  footerModalBoxStyle,
  footerModalOverlayStyle
} from '../styles/footerModalStyles'

const CookiesModal = ({ open, onClose, openedFrom }) => {
  const { t } = useTranslation()
  const [hoverBtn, setHoverBtn] = useState(null)
  const [pressedBtn, setPressedBtn] = useState(null)

  useEffect(() => {
    if (!open) return

    const handleKeyDown = e => {
      if (e.key === 'Escape') {
        if (openedFrom === 'checkbox') return
        onClose()
      }
    }

    window.addEventListener('keydown', handleKeyDown)

    return () => {
      window.removeEventListener('keydown', handleKeyDown)
    }
  }, [open, onClose, openedFrom])

  if (!open) return null

  const cookies = {
    COOKIES_TITLE: t('COOKIES_TITLE'),
    COOKIES_TEXT: t('COOKIES_TEXT')
  }

  return (
    <>
      <div
        onClick={() => {
          if (openedFrom === 'checkbox') return
          onClose()
        }}
        style={footerModalOverlayStyle()}
      />

      <div style={footerModalBoxStyle()}>
        <div
          style={{
            marginBottom: 8,
            fontWeight: 'bold',
            fontSize: 24
          }}
        >
          {cookies.COOKIES_TITLE}
        </div>

        <div
          style={{
            whiteSpace: 'pre-line',
            fontSize: 16
          }}
        >
          {cookies.COOKIES_TEXT}
        </div>

        <div style={footerModalActionsStyle}>
          <button
            onClick={onClose}
            style={primaryButtonStyle(
              pressedBtn,
              'cookies-close',
              hoverBtn === 'cookies-close'
            )}
            onMouseEnter={() => setHoverBtn('cookies-close')}
            onMouseLeave={() => {
              setHoverBtn(null)
              setPressedBtn(null)
            }}
            onMouseDown={() => setPressedBtn('cookies-close')}
            onMouseUp={() => setPressedBtn(null)}
          >
            {openedFrom === 'checkbox' ? t('AGREE') : t('CLOSE')}
          </button>
        </div>
      </div>
    </>
  )
}

export default CookiesModal